import { render } from "./Disdrometro.vue?vue&type=template&id=5e49f9a8"
import script from "./Disdrometro.vue?vue&type=script&lang=js"
export * from "./Disdrometro.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__